module.exports = __webpack_public_path__ + "static/media/Bull_Riding-17.51cf7726.jpg";